<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deletePopup">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="col-md-12">   
            <KTCard v-bind:title="title">
                <template v-slot:body>
                    <form ref="form" id="form" novalidate="novalidate" lazy-validation class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                        <div class="m-portlet__body">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Başlık:</label>
                                <div class="col-lg-9">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="popup.title">
                                    <div v-if="errors.title" :errors="errors">
                                        <b-badge v-for="error in errors.title" class="mr-1" :key="error.title" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Gösterileceği Sayfalar:</label>
                                <div class="col-lg-9">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="popup.display_pages">
                                    <div v-if="errors.display_pages" :errors="errors">
                                        <b-badge v-for="error in errors.display_pages" class="mr-1" :key="error.display_pages" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Başlangıç Tarihi:</label>
                                <div class="col-lg-9">
                                    <input type="datetime-local" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="popup.start_date">
                                    <div v-if="errors.start_date" :errors="errors">
                                        <b-badge v-for="error in errors.start_date" class="mr-1" :key="error.start_date" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Bitiş Tarihi:</label>
                                <div class="col-lg-9">
                                    <input type="datetime-local" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="popup.end_date">
                                    <div v-if="errors.end_date" :errors="errors">
                                        <b-badge v-for="error in errors.end_date" class="mr-1" :key="error.end_date" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Aktif mi?:</label>
                                <div class="col-lg-9">
                                    <b-form-checkbox value="1" switch size="lg" :class="{view: !isEditing}" :disabled="!isEditing" v-model="popup.is_active"></b-form-checkbox>
                                    <div v-if="errors.is_active" :errors="errors">
                                        <b-badge v-for="error in errors.is_active" class="mr-1" :key="error.is_active" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Popup Görseli:
                                    <span class="form-text text-muted">İzin verilen belge türleri: png, jpg, jpeg, pdf.</span>
                                </label>
                                <div class="col-lg-9">
                                    <input 
                                        class="form-control" 
                                        type="file" 
                                        id="formFileMultiple" 
                                        name="popup_file"
                                        ref="rpopup_file"
                                        :class="{view: !isEditing}" 
                                        :disabled="!isEditing" 
                                        @change="onFileChange" 
                                    />
                                    <div v-if="errors.popup_file" :errors="errors">
                                        <b-badge v-for="error in errors.popup_file" class="mr-1" :key="error.popup_file" variant="danger">{{ error }}</b-badge>
                                    </div> 
                                    </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Mevcut Popup Görseli:</label>
                                <div class="col-lg-9">
                                    <a 
                                        target="_blank" 
                                        v-for="document in popup.popup_images" 
                                        :key="document.id"
                                        :href="getLink(document.id, document.file_name)" 
                                    >
                                        <b-badge variant="warning" class="mr-1">
                                            {{ document.file_name }}
                                        </b-badge>
                                    </a>
                                </div>
                            </div>
                            
                            <template v-if="timeStamps">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleyen:</label>
                                    <div class="col-lg-9">
                                        {{ popup.user_created_name }}
                                    </div>
                                </div>
                                
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ popup.created_at | formatDateTime }}</span>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleyen:</label>
                                    <div class="col-lg-9">
                                        {{ popup.user_updated_name }}
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ popup.updated_at | formatDateTime }}</span>
                                    </div>
                                </div>

                        </template>
                          
                        </div>
                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-3"></div>
                                    <div class="col-lg-9">
                                        <!-- EKLEME BUTONLARI -->
                                        <template v-if="addButtons">
                                            <b-button
                                                v-if="hasPermission('popups.create')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="savePopupAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Kaydet ve Geri Dön
                                            </b-button>
                                            
                                            <b-button
                                                v-if="hasPermission('popups.create')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="savePopupAndAddNew()"
                                            >
                                            <i class="la la-save"></i>
                                                Kaydet ve Yeni Ekle
                                            </b-button>
                                        </template>

                                        <!-- GÜNCELLEME BUTONLARI -->
                                        <template v-if="editButtons">  
                                            <b-button
                                                v-if="hasPermission('popups.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="updatePopupAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Güncelle ve Geri Dön
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('popups.update')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="updatePopup()"
                                            >
                                            <i class="la la-save"></i>
                                                Güncelle
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('popups.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            
                                            
                                        </template>

                                        <!-- GÖRÜNTÜLEME BUTONLARI -->
                                        <template v-if="viewButtons">
                                            <b-button
                                                v-if="hasPermission('popups.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('popups.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="changeFormToEditing()"
                                            >
                                            <i class="la la-edit"></i>
                                                Güncellemeyi Aktif Et
                                            </b-button>
 
                                        </template>   
                                        <template>
                                            <b-button 
                                                size="sm" 
                                                @click="$router.go(-1)">
                                                <i class="la la-undo"></i>
                                                İptal
                                            </b-button> 
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
            </KTCard>
        </div>
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
    
    </div>



    
</template>

<script>

import Vue from "vue";
import KTCard from "@/view/content/Card.vue";
import { mapGetters} from 'vuex';
import { mapState} from 'vuex';
import { GET_POPUP_DATA } from "@/core/services/store/popups.module";
import { CREATE_POPUP } from "@/core/services/store/popups.module";
import { UPDATE_POPUP } from "@/core/services/store/popups.module";
import { DELETE_POPUP } from "@/core/services/store/popups.module";
//import Multiselect from 'vue-multiselect'

//import Echo from 'laravel-echo';

export default {
    name: "popups-form",
    
    data() {
        return {
            dialog: false,
            popup:{
                images: [],
                user_created_name: "",
                user_updated_name: ""
            },
            formType: "",
            title: "",
            addButtons: false,
            editButtons: false,
            viewButtons: false,
            timeStamps: false,
            isEditing: true,
            popups: {},
            options: [
                { value: '1', text: 'Evet', selected: true },
                { value: '0', text: 'Hayır' },
            ],

            value: [],
                        
        };
    },
   
    methods: {
        onFileChange(e) {
            this.popup.images = [];
            for (let file of e.target.files) {
                
                if (typeof FileReader === "function") {
                    let reader = new FileReader();
                    reader.onload = event => {
                        this.popup.images.push({
                            name: file.name,
                            content: event.target.result,
                        });
                        
                    };
                    reader.readAsDataURL(file); 
                }
            }
        },

        savePopupAndGoBack() {
            const data = this.popup;
            this.popup.popup_file = this.$refs.rpopup_file.value;
            const goBack = true;
            this.$store.dispatch(CREATE_POPUP, {data, goBack})
        },

        savePopupAndAddNew() {
            const data =  this.popup;
            this.popup.popup_file = this.$refs.rpopup_file.value;
            const goBack = false;
            this.$store.dispatch(CREATE_POPUP, {data, goBack})
        },

        updatePopupAndGoBack() {
            const data = this.popup;
            const goBack = true;
            this.$store.dispatch(UPDATE_POPUP, { data, goBack })
        },

        updatePopup() {
            const data = this.popup;
            const goBack = false;
            this.$store.dispatch(UPDATE_POPUP, { data, goBack })
        },

        deletePopup() {
            var itemToDelete = this.popup.id;
            this.$store.dispatch(DELETE_POPUP, { itemToDelete })
            .then(() => { 
                this.$router.go(-1);
                this.dialog = false;
            })
        },

        changeFormToAdding(){
            this.title = "Parametre: Yeni Kayıt Formu"
            
            this.addButtons = true;
            this.editButtons = false;
            this.viewButtons = false;
            this.timeStamps = false;
            this.isEditing = true;
        },

        changeFormToEditing(){
            this.title = "Parametre: Güncelleme Formu"
            this.addButtons = false;
            this.editButtons = true;
            this.viewButtons = false;
            this.timeStamps = true;
            this.isEditing = true;
        },

        changeFormToViewing(){
            this.title = "Parametre: Detaylar"
            this.addButtons = false;
            this.editButtons = false;
            this.viewButtons = true;
            this.timeStamps = true;
            this.isEditing = false;
        },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },

        getLink(id, file_name) {
            return Vue.axios.defaults.baseURL+`/../storage/uploads/popups/${id}/${file_name}`
        }

    },


    components: {
        KTCard,
        //Multiselect
    },

    created() {
        this.isEditing = !this.isEditing;
        this.formType = this.$route.params.formType;
        this.$store.dispatch('getUserMenu');
        this.$store.dispatch('createPopupForm');
        this.popup.is_active = 1;
        if (this.formType != "add") {
            var id = this.$route.params.id;
            this.$store.dispatch(GET_POPUP_DATA, { id })
            .then(( response ) => {
                this.popup = response.data;
                this.popup.user_created_name = response.data.user_created_name[0].name;
                this.popup.user_updated_name = response.data.user_updated_name[0].name;
            })
        }
    },

    mounted() {
        
        if(this.formType === "add"){
            this.changeFormToAdding();
        }
        if(this.formType === "edit"){
            this.changeFormToEditing();
        }
        if(this.formType === "view"){
            this.changeFormToViewing();
        }
    },

    computed: {
        ...mapGetters(["currentUserMenu"]),

        ...mapState({
            loading: state => state.popups.loading,
            row: state => state.popups.row,
            errors: state => state.popups.errors,
            isDisabled: state => state.popups.isDisabled,
            //user: state => state.users.user_data
        })
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}
</style>
